import { Instance } from 'mobx-state-tree'
import { DayTournamentSchedulesModelBase } from './DayTournamentSchedulesModel.base'

/* The TypeScript type of an instance of DayTournamentSchedulesModel */
export interface DayTournamentSchedulesModelType extends Instance<typeof DayTournamentSchedulesModel.Type> {}

/* A graphql query fragment builders for DayTournamentSchedulesModel */
export {
  selectFromDayTournamentSchedules,
  dayTournamentSchedulesModelPrimitives,
  DayTournamentSchedulesModelSelector
} from './DayTournamentSchedulesModel.base'

/**
 * DayTournamentSchedulesModel
 */
export const DayTournamentSchedulesModel = DayTournamentSchedulesModelBase.actions((self) => ({
  // This is an auto-generated example action.
  log() {
    console.log(JSON.stringify(self))
  }
}))
